
<template>
  <main-layout
    v-if="currentPage === 'coverage'"
    title="Coverage"
  >
    <template slot="rightElements">
      <month-picker
        v-if="selectedDate"
        :selectedGlobalDate="selectedDate"
        @new-month-date="setNewMonthDate"
      />
    </template>
    <div slot="content">
      <Coverage />
    </div>
  </main-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { subMonths } from 'date-fns'
import MainLayout from '@/layouts/Main'
import Coverage from '@/components/coverage/Index'
import MonthPicker from '@/components/parts/MonthPicker/Index'

export default {
  components: {
    MainLayout,
    MonthPicker,
    Coverage
  },
  computed: {
    ...mapGetters({
      selectedDate: 'charts/coverageSelectedDate',
      currentPage: 'charts/currentPage'

    })
  },
  created () {
    if (!this.selectedDate) {
      const date = subMonths(new Date(), 1)
      this.setCoverageDate(date)
    }
  },
  methods: {
    ...mapActions('charts', [
      'setCoverageDate'
    ]),
    setNewMonthDate (date) {
      this.setCoverageDate(date)
    }
  }
}
</script>
